import { Component } from 'react';
import { compose } from 'redux';
import AdminTable from 'layouts/AdminTable';
import withStyles from '@material-ui/core/styles/withStyles';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle';
import FormControlButtons from 'components/FormControlButtons/FormControlButtons';
import DataGrid from 'components/DataGrid/DataGrid';
import { isGranted } from 'helpers/helpers';
import { ROLE_CREATE_ZONE_CATEGORY } from 'helpers/roles';
import { withTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import columnConfig from './columnConfig';

class List extends Component {
  state = {
    openedModal: false,
    file: null,
    isImporting: false,
    importButtonClicked: false,
  };

  componentDidMount() {
    const successfullyAddedZoneCategory =
      !!this.props.location.state?.successfullyAddedZoneCategory;

    if (successfullyAddedZoneCategory) {
      toast.success(this.props.t('zoneCategories.successAdded'));
    }
  }

  newZone = () => this.props.history.push(`${window.location.pathname}/add`);

  render() {
    const { classes, t } = this.props;

    return (
      <AdminTable title={t('zoneCategories.list')}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          {isGranted(ROLE_CREATE_ZONE_CATEGORY) && (
            <FormControlButtons
              classes={classes}
              handleSubmit={this.newZone}
              submitText={`${t('zoneCategories.add')} +`}
            />
          )}
        </div>
        <DataGrid
          actions={true}
          editPath={`${window.location.pathname}/edit`}
          remove={true}
          export={true}
          paginationTop={true}
          paginationBottom={false}
          url="/zone-categories"
          reportName="zoneCategory"
          columns={columnConfig}
          role="ZONE_CATEGORY"
        />
      </AdminTable>
    );
  }
}

const enhance = compose(withStyles(buttonsStyle), withTranslation());

export default enhance(List);
